import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../store/store';
import { useSelector } from 'react-redux';
import { selectCurrentProject } from '../../store/selectors/projectSelectors';
import { fetchProject } from '../../shared/api/textProjectApi';
import { fetchProjectNotes } from '../../store/slices/notesSlice';

export function useFetchProject() {
    const dispatch = useAppDispatch();
    const { projectId } = useParams();
    useEffect(() => {
        if (projectId) {
            dispatch(fetchProject({ projectId }));
            dispatch(fetchProjectNotes({ projectId }));
        }
    }, [projectId, dispatch]);
}
